import React, { useEffect, useState } from "react";
import dayjs from "dayjs";

import { useRecoilState, useSetRecoilState } from "recoil";
import { dateReset, dateState } from "lib/store/common";
import { currentThreadFilter } from "lib/store/dashboard";

import { ReactComponent as Pre } from "assets/pre_arrow_btn.svg";
import { ReactComponent as Next } from "assets/next_arrow_btn.svg";

import { Box, Button, Checkbox } from "@atsent/components";

import { ExportModal } from "components/modals/ExportModal";

import "./DashboardDateToolbar.scss";
import { threadPageState } from "../../../lib/store/thread";

export type DashboardDateToolbarProps = {
  cx?: string;
};

const MonthButton = ({ month }: { month: number }) => {
  const [curDate, setCurDate] = useRecoilState(dateState);
  return (
    <label>
      <input
        type={"radio"}
        name={"select-date"}
        value={month}
        defaultChecked={curDate.moveMonth === month}
        onChange={(e) => {
          if (!e.target.checked) return;
          setCurDate((cur) => ({
            ...cur,
            moveMonth: month,
            range: {
              first: dayjs().subtract(month, "month"),
              last: dayjs().add(1, "day"),
            },
          }));
        }}
      />
      <span className="select-date-wrapper">
        <span>{month}개월</span>
      </span>
    </label>
  );
};

export const DashboardDateToolbar: React.FC<DashboardDateToolbarProps> = ({
  cx = "",
}) => {
  const [curDate, setCurDate] = useRecoilState(dateState);
  const [filter, setFilter] = useRecoilState(currentThreadFilter);
  const resetLists = useSetRecoilState(dateReset);
  const setPage = useSetRecoilState(threadPageState);
  const [openModal, setOpenModal] = useState({
    export: false,
  });

  useEffect(() => {
    resetLists((res) => res);
  }, [curDate, resetLists, filter]);

  return (
    <>
      <Box cx={`DashboardDateToolbar ${cx}`}>
        <Pre
          onClick={() => {
            setCurDate((_) => ({
              ..._,
              range: {
                first: dayjs(_.range.first).subtract(_.moveMonth, "month"),
                last: dayjs(_.range.last).subtract(_.moveMonth, "month"),
              },
            }));
          }}
        />
        <div className="date-wrapper">
          <span>{curDate.range.first.format("YYYY.MM.DD")}</span>
          <span className={"wave"}>~</span>
          <span>
            {curDate.range.last.subtract(1, "day").format("YYYY.MM.DD")}
          </span>
        </div>
        <Next
          onClick={() => {
            setCurDate((_) => ({
              ..._,
              range: {
                first: dayjs(_.range.first).add(_.moveMonth, "month"),
                last: dayjs(_.range.last).add(_.moveMonth, "month"),
              },
            }));
          }}
        />
        <MonthButton month={1} />
        <MonthButton month={3} />
        <MonthButton month={6} />
        <MonthButton month={12} />
        <div className={"channel-wrapper"}>
          <Checkbox
            label={"CSV"}
            defaultChecked={filter.words}
            onChange={async () => {
              await setPage(0);

              await setFilter((_) => ({ ..._, words: !_.words }));
            }}
          />
          <Checkbox
            label={"구글플레이"}
            defaultChecked={filter["google-play"]}
            onChange={async () => {
              await setPage(0);
              await setFilter((_) => ({
                ..._,
                "google-play": !_["google-play"],
              }));
            }}
          />
          <Checkbox
            label={"앱스토어"}
            defaultChecked={filter["app-store"]}
            onChange={async () => {
              await setPage(0);
              await setFilter((_) => ({ ..._, "app-store": !_["app-store"] }));
            }}
          />
          <Checkbox
            label={"채널톡"}
            defaultChecked={filter["channel-talk"]}
            onChange={async () => {
              await setPage(0);
              await setFilter((_) => ({
                ..._,
                "channel-talk": !_["channel-talk"],
              }));
            }}
          />
        </div>
        <div className="button-wrapper">
          <Button
            outline
            size={"small"}
            click={() => setOpenModal((_) => ({ ..._, export: true }))}
          >
            내보내기
          </Button>
          {/*<Button outline size={'small'}>*/}
          {/*  공유*/}
          {/*</Button>*/}
        </div>
      </Box>
      {openModal.export && (
        <ExportModal
          close={() => setOpenModal((_) => ({ ..._, export: false }))}
        />
      )}
    </>
  );
};
